import React from "react";
import { Tooltip } from "antd";
import {
  TableLabel,
  Title,
  CustomizedIcon,
  UnderlyingContent
} from "../../Epics/Grants/Pages/RecommendGrant/style";
import { addressFormat } from "../../Epics/Grants/Pages/RecommendGrant/utils";
import { CapsuleButton } from "../Commons/commonComponents";

export const geminiTableConfig = (
  pendingCharityHandler,
  savedGeminiModal,
  removedGeminiModal,
  activityBlocked = ""
) => {
  return [
    {
      title: () => <div />,
      dataIndex: "isSelected",
      key: "isSelected",
      render: (value, record) => {
        if (record.loading) {
          return <CustomizedIcon type="loading" />;
        }
        return (
          <div>
            {value ? (
              <Tooltip placement="right" title="Remove Charity">
                <CustomizedIcon
                  data-test="customised-icon-onClick"
                  type="star"
                  theme="filled"
                  onClick={() => savedGeminiModal(record)}
                />
              </Tooltip>
            ) : (
              <Tooltip placement="right" title="Save Charity">
                <CustomizedIcon
                  type="star"
                  theme="outlined"
                  data-test="customised-icon-outlined"
                  onClick={() => removedGeminiModal(record)}
                />
              </Tooltip>
            )}
          </div>
        );
      },
      width: 10
    },
    {
      title: () => <Title>Legal Name</Title>,
      dataIndex: "legalName",
      key: "legalName",
      render: (value, record) => {
        return <TableLabel>{value} </TableLabel>;
      },
      width: 180
    },
    {
      title: () => <Title>EIN</Title>,
      dataIndex: "ein",
      key: "ein",
      render: value => {
        return <TableLabel>{value} </TableLabel>;
      },
      width: 124
    },
    {
      title: () => <Title>Address</Title>,
      dataIndex: "city",
      key: "city",
      render: (value, record) => {
        return (
          <Tooltip
            placement="bottom"
            title={addressFormat({
              addressLine1: record.addressLine1,
              addressLine2: record.addressLine2,
              city: record.city,
              state: record.state,
              zipCode: record.zip
            })}
          >
            <UnderlyingContent id="anrAddressCity">{value + "," + record.state}</UnderlyingContent>
          </Tooltip>
        );
      },
      width: 147
    },
    {
      title: () => <Title>Interest Area</Title>,
      dataIndex: "interestArea",
      key: "interestArea",
      render: value => {
        return <TableLabel>{value} </TableLabel>;
      },
      width: 130
    },
    {
      title: () => <div />,
      dataIndex: "isPending",
      key: "isPending",
      render: (value, record) => {
        return (
          <div>
            <CapsuleButton 
              text = "Select"
              id="btnGeminiIsPendingSelect"
              onClick={() => pendingCharityHandler(record)}
              disabled={!!activityBlocked || record.loading}
              title={activityBlocked}
              whiteBackground = {true}
              iconType = "arrowRight"
              alt = "Right arrow"
            />
          </div>
        );
      },
      width: 10
    }
  ];
};
